<template>
  <div class="card shadow" style="min-height: 100%">
    <a-modal title="Warning" :visible="modalVisible" @ok="massupdate('status', 'D')" @cancel="modalVisible = false">
      All changes to be made cannot be reverted. Are you sure you want to delete
      the selected products?
    </a-modal>

    <div class="card-header border-0" :class="type === 'dark' ? 'bg-transparent' : ''">
      <div class="row align-items-center">
        <div id="errorNotification" class="col-md-12">
          <base-alert v-if="errorMessage != null" type="danger">
            <span class="alert-inner--text"> {{ errorMessage }}</span>
            <button type="button" class="close" aria-label="Close" @click="removeMessage('error')">
              <span aria-hidden="true">&times;</span>
            </button>
          </base-alert>
          <base-alert v-if="successMessage != null" type="success">
            <span class="alert-inner--text"> {{ successMessage }}</span>
            <button type="button" class="close" aria-label="Close" @click="removeMessage('success')">
              <span aria-hidden="true">&times;</span>
            </button>
          </base-alert>
          <stock-card v-if="selectedProduct != null" :product="selectedProduct" :key="stockCardKey" :icon_code="icon_code"
            :visible="stockCardVisible"></stock-card>
        </div>

        <div class="col-md-6">
          <h2>{{ this.title }}</h2>
        </div>

        <div class="col-md-6 text-right">
          <!-- <div v-if="massUpdateMode == true">" -->
          <base-dropdown class="nav-link pr-0 float-right" position="right"
            v-if="massUpdateMode == false || massUpdateMode == null">
            <div class="media align-items-center" slot="title">
              <i class="fa fa-ellipsis-v float-right ml-2 btn-sm"></i>
            </div>
            <template>
              <div class="dropdown-header noti-title">
                <h6 class="text-overflow m-0">PRODUCT LIST ACTIONS</h6>
              </div>
              <!-- <div v-if="accessRights.includes('T')" class="dropdown-item"
                @click.prevent="showActionDrawer('print_list')">
                <i class="fa fa-print"></i>
                <span>Print</span>
              </div> -->
              <div v-if="serverType == 'ho' && site_type == 'ho' && accessRights.includes('I')" class="dropdown-item d-none"
                @click.prevent="showTestImportModal">
                <i class="fa fa-upload"></i>
                <span>Test Import</span>
              </div>

              <div v-if="serverType == 'ho' && site_type == 'ho' && accessRights.includes('I')" class="dropdown-item"
                @click.prevent="showActionDrawer('import_list')">
                <i class="fa fa-upload"></i>
                <span>Import</span>
              </div>

              <div v-if="serverType == 'ho' && site_type == 'ho' && accessRights.includes('I')" class="dropdown-item"
                @click.prevent="showActionDrawer('import_alternate_barcode_list')">
                <i class="fa fa-upload"></i>
                <span>Import Alternate Barcode</span>
              </div>

              <div v-if="accessRights.includes('E')" class="dropdown-item"
                @click.prevent="showActionDrawer('export_list')">
                <i class="fa fa-download"></i>
                <span>Export</span>
              </div>
              <div v-if="serverType == 'ho' && site_type == 'ho' && accessRights.includes('W')" class="dropdown-divider"></div>
              <div v-if="serverType == 'ho' && site_type == 'ho' && accessRights.includes('W')" class="dropdown-header noti-title">
                <h6 class="text-overflow m-0">PRODUCT UPDATES ACTIONS</h6>
              </div>
              <div v-if="serverType == 'ho' && site_type == 'ho' && accessRights.includes('W')" class="dropdown-item"
                @click.prevent="changeMode">
                <i class="fa fa-object-group"></i>
                <span>Mass Update Products</span>
              </div>
              <div class="dropdown-divider"></div>
              <div class="dropdown-header noti-title">
                <h6 class="text-overflow m-0">PX SETTINGS</h6>
              </div>
              <div class="dropdown-item" @click.prevent="showActionDrawer('customize_list')">
                <i class="fa fa-list-ul"></i>
                <span>Customize List</span>
              </div>
              <div v-if="serverType == 'ho' && site_type == 'ho' && accessRights.includes('G')" class="dropdown-item" @click.prevent="showActionDrawer('configuration')">
                <i class="fa fa-cog"></i>
                <span>Configuration</span>
              </div>
              <div v-if="serverType == 'ho' && site_type == 'ho' && accessRights.includes('G')" class="dropdown-item" @click.prevent="showActionDrawer('configurationhist')">
                <i class="fa fa-history"></i>
                <span>Configuration History</span>
              </div>
            </template>
            <!-- <template v-else>
              <div class=" dropdown-header noti-title">
                <h6 class="text-overflow m-0">MASS UPDATE ACTIONS</h6>
              </div>
              <div class="dropdown-item" @click.prevent="showActionDrawer('print_list')">
                <i class="fa fa-check-circle"></i>
                <span>Select All</span>
              </div>
            </template> -->
          </base-dropdown>

          <div v-if="massUpdateMode == false || massUpdateMode == null">
            <!-- {{this.accessRights}} -->
            <div v-if="serverType == 'ho' && site_type == 'ho'">
              <div v-if="selectedRowKeys.length == 0 && accessRights.includes('A')">
                <base-dropdown class="nav-link" position="right">
                  <div class="media align-items-center" slot="title">
                    <base-button class="float-right ml-1" type="primary" size="sm">+ Add
                      {{
                          _.startCase(_.singularize(currentProfile))
                      }}</base-button>
                  </div>
                  <template>
                    <div class="dropdown-header noti-title">
                      <h6 class="text-overflow m-0 text-muted">
                        SELECT PRODUCT TYPE
                      </h6>
                    </div>
                    <div v-if="enable_regular == true" class="dropdown-item" @click.prevent="showDrawer(0, '', 0)">
                      <img class="product-icons" :src="require(`../../assets/icons/${icon_code}/regular.png`)" alt="">
                      <span>Regular Product</span>
                    </div>
                    <div v-if="enable_combo == true && icon_code == 'FNB'" class="dropdown-item" @click.prevent="showDrawer(0, 'B', 0)">
                      <img class="product-icons" :src="require(`../../assets/icons/${icon_code}/combo.png`)" alt="">
                      <span>Combo Product</span>
                    </div>
                    <div v-if="enable_packaged == true" class="dropdown-item" @click.prevent="showDrawer(0, 'P', 0)">
                      <img class="product-icons" :src="require(`../../assets/icons/${icon_code}/packaged.png`)" alt="">
                      <span>Packaged Product</span>
                    </div>
                    <div v-if="enable_gift_certificate == true" class="dropdown-item" @click.prevent="showDrawer(0, 'G', 0)">
                      <img class="product-icons" :src="require(`../../assets/icons/${icon_code}/regular.png`)" alt="">
                      <span>Gift Certificate Product</span>
                    </div>
                    <div v-if="enable_matrix == true" class="dropdown-item" @click.prevent="showDrawer(0, 'M', 0)">
                      <img class="product-icons" :src="require(`../../assets/icons/${icon_code}/matrix.png`)" alt="">
                      <span>Matrix Product</span>
                    </div>
                    <div v-if="enable_kit == true" class="dropdown-item" @click.prevent="showDrawer(0, 'K', 0)">
                      <img class="product-icons" :src="require(`../../assets/icons/${icon_code}/kit.png`)" alt="">
                      <span>Kit</span>
                    </div>
                    <div v-if="enable_virtual_kit == true" class="dropdown-item" @click.prevent="showDrawer(0, 'V', 0)">
                       <img class="product-icons" :src="require(`../../assets/icons/${icon_code}/virtual_kit.png`)" alt="">
                      <span>Virtual Kit</span>
                    </div>
                    <div v-if="enable_non_inventory" class="dropdown-item" @click.prevent="showDrawer(0, 'N', 0)">
                       <img class="product-icons" :src="require(`../../assets/icons/${icon_code}/non_inventory.png`)" alt="">
                      <span>Non-Inventory Tracking Item</span>
                    </div>
                    <div v-if="enable_serial == true" class="dropdown-item" @click.prevent="showDrawer(0, 'S', 0)">
                      <img class="product-icons" :src="require(`../../assets/icons/${icon_code}/serial.png`)" alt="">
                      <span>Serial Item</span>
                    </div>
                    <div v-if="enable_recipe == true  && icon_code == 'FNB'" class="dropdown-item" @click.prevent="showRecipeDrawer(0)">
                       <img class="product-icons" :src="require(`../../assets/icons/${icon_code}/recipe.png`)" alt="">
                      <span>Recipe</span>
                    </div>
                  </template>
                </base-dropdown>
              </div>

              <div v-else-if="
                selectedRowKeys.length > 0 && accessRights.includes('W')
              ">
                <base-button class="float-right ml-1 mt-1" type="danger" size="sm" @click.prevent="modalVisible = true">
                  Delete Selected</base-button>
                <base-dropdown class="nav-link" position="right">
                  <div class="media align-items-center" slot="title">
                    <base-button class="float-right ml-1" type="info" size="sm">Change Status</base-button>
                  </div>
                  <template>
                    <div class="dropdown-header noti-title">
                      <h6 class="text-overflow m-0 text-muted">
                        Select Status
                      </h6>
                    </div>
                    <div class="dropdown-item" @click.prevent="massupdate('status', 'A')">
                      <span>Active</span>
                    </div>
                    <div class="dropdown-item" @click.prevent="massupdate('status', 'I')">
                      <span>Inactive</span>
                    </div>
                    <div class="dropdown-item" @click.prevent="massupdate('status', 'P')">
                      <span>Phased Out</span>
                    </div>
                  </template>
                </base-dropdown>
              </div>
            </div>
          </div>

          <div v-if="massUpdateMode == true">
            <small> {{ this.productList.length }} products selected </small>
            <button type="button" class="btn btn-sm btn-danger ml-2" style="width: 20%" @click.prevent="changeMode">
              Cancel
            </button>
            <!-- <router-link :to="{path: 'product_updates', query: { selected-products: productList }}">Link Text</router-link> -->
            <button type="button" class="btn btn-sm btn-default" style="width: 20%"
              :disabled="this.productList.length == 0" @click.prevent="showMassUpdater">
              Next
            </button>
            <br />
            <button v-if="this.copyData.length > 0" type="button" class="btn btn-sm btn-secondary mt-3 mr-2"
              style="width: 20%" @click.prevent="addAllProduct">
              Select All
            </button>
            <button v-if="this.copyData.length > 0" type="button" class="btn btn-sm btn-secondary mt-3 mr-2"
              style="width: 20%" @click.prevent="removeAllProduct">
              Deselect All
            </button>
            <base-dropdown class="nav-link pr-0 float-right" style="margin-top: 15px;" position="right">
              <div class="media align-items-center" slot="title">
                <i class="fa fa-ellipsis-v float-right ml-2 btn-sm"></i>
              </div>
                <template>
                  <div class="dropdown-header noti-title">
                    <h6 class="text-overflow m-0">PRODUCT MASS UPDATE ACTIONS</h6>
                  </div>
                  <div class="dropdown-item" @click.prevent="showActionDrawer('mass_import_list')">
                    <i class="fa fa-upload"></i>
                    <span>Import Product</span>
                  </div>
                </template>
            </base-dropdown>
          </div>
        </div>
      </div>
    </div>

    <a-drawer title="" :width="width" placement="right" @close="onClose" :visible="drawerVisible">
      <div v-if="profileAction == 'configurationhist'">
        <document-configuration-history @closeDrawer="closeDrawer" v-on:refreshPage="refreshPage" :key="componentKey">
          asa</document-configuration-history>
      </div>

      <div v-if="profileAction == 'customize_list'">
        <h6 class="heading-small text-muted mb-4">Customize Fields</h6>
        <!-- <small>Check the fields that you want to see on the list. Drag the fields to
          specify position.</small>
        <br /><br /> -->

        <div class="list-group list-group-item">
          <div class="row">
            <div class="col-md-6"><b>AVAILABLE FIELDS</b></div>
            <div class="col-md-6">
              <a-checkbox class="float-right" @change="onCheckAllField" :checked="
                this.checkedFields.length == this.availableFields.length
              " />
            </div>
          </div>
        </div>

        <div class="list-group-item" :style="
                    index == availableFields.length - 1 ? 'margin-bottom: 50px;' : ''
                  " v-for="(element, index) in availableFields" :key="element">
          <div class="row">
            <!-- This _.startCase() will convert any casing into Start Case -->
            <div class="col-md-6">{{ _.startCase(element) }}</div>
            <div class="col-md-6">
              <a-checkbox class="float-right" @change="onCheckField(element)" :checked="checkedFields.includes(element)" />
            </div>
          </div>
        </div>
        <!-- <draggable :key="draggableKey" :list="availableFields" :disabled="!enabled" class="list-group"
          @start="dragging = true" @end="dragging = false">
          <div class="list-group-item" :style="
            index == availableFields.length - 1 ? 'margin-bottom: 50px;' : ''
          " v-for="(element, index) in availableFields" :key="element">
            <div class="row"> -->
              <!-- This _.startCase() will convert any casing into Start Case -->
              <!-- <div class="col-md-6">{{ _.startCase(element) }}</div>
              <div class="col-md-6">
                <a-checkbox class="float-right" @change="onCheckField(element)"
                  :checked="checkedFields.includes(element)" />
              </div>
            </div>
          </div>
        </draggable> -->     

     
        <div class="float-right" style="position: absolute; bottom: 20px; left: 20px">
          <button class="btn btn-danger float-right" @click.prevent="resetFields">
            Reset Fields
          </button>
        </div>
        <div class="float-right" style="position: absolute; bottom: 20px; right: 20px">
          <button class="btn btn-primary float-right" @click.prevent="updateTableList">
            Update List
          </button>
        </div>
      </div>

      <div v-if="profileAction == 'export_list'">
        <h6 class="heading-small text-muted mb-4">Filters</h6>
        <div>

          <div class="col-md-12">
            <base-input label="Company">
            <a-select showSearch v-model="inputCompanies" mode="multiple" optionFilterProp="children" style="width: 100%" :filterOption="filterOption" placeholder="All" allowClear>
                <a-select-option v-for="companyOption in companyOptions" :key="companyOption.id" :value="companyOption.id">{{companyOption.name}}</a-select-option>
            </a-select>
            </base-input>
          </div>

          <div class="col-md-12">
            <base-input label="Brand">
            <a-select showSearch v-model="inputBrands" mode="multiple" optionFilterProp="children" style="width: 100%" :filterOption="filterOption" placeholder="All" allowClear>
                <a-select-option v-for="brandOption in brandOptions" :key="brandOption.id" :value="brandOption.id">{{brandOption.name}}</a-select-option>
            </a-select>
            </base-input>
          </div>

          <div class="col-md-12">
            <base-input label="Main Category">
            <a-select showSearch v-model="inputCategories" mode="multiple" optionFilterProp="children" style="width: 100%" :filterOption="filterOption" placeholder="All" allowClear>
                <a-select-option v-for="categoryOption in categoryOptions" :key="categoryOption.id" :value="categoryOption.id">{{categoryOption.name}}</a-select-option>
            </a-select>
            </base-input>
          </div>

          <div class="col-md-12">
            <base-input alternative="" label="Create Date"><br>
                <a-range-picker v-model="inputProductCreateDate" :showTime="{ format: 'hh:mm' }" format="MM/DD/YYYY hh:mm A" :placeholder="['Start Date', 'End Date']" style="width:100%"/>
            </base-input>
          </div>

          <div class="col-md-12">
            <base-input alternative="" label="Update Date"><br>
                <a-range-picker v-model="inputProductUpdateDate" :showTime="{ format: 'hh:mm' }" format="MM/DD/YYYY hh:mm A" :placeholder="['Start Date', 'End Date']" style="width:100%"/>
            </base-input>
          </div>

          <div class="col-md-12">
            <base-input label="Status">
            <a-select showSearch v-model="inputStatus" optionFilterProp="children" style="width: 100%" :filterOption="filterOption">
                <a-select-option v-for="val in exportStatusOptions" :key="val.code" :value="val.code">{{val.name}}</a-select-option>
            </a-select>
            </base-input>
          </div>

          <div class="col-md-12">
            <base-input alternative="" label="Year Season">
              <a-input type="text" placeholder="Input Year Season" v-model="inputYearSeason"/>
            </base-input>
          </div>

          <div class="col-md-12" v-if="enableExportTypeFilter">
            <base-input label="Export Type">
            <a-select showSearch v-model="inputExportType" optionFilterProp="children" style="width: 100%" :filterOption="filterOption">
                <a-select-option v-for="val in exportTypeOptions" :key="val.code" :value="val.code">{{val.name}}</a-select-option>
            </a-select>
            </base-input>
          </div>

          <div class="col-md-12">
            <base-radio name="item_master" class="mb-3" v-model="filterStatus" value="item_master">
              Item Master
            </base-radio>
            <base-radio name="ecom_master" class="mb-3" v-model="filterStatus" value="ecom_master">
              Ecom Master
            </base-radio>
            <base-radio v-if="enableNsItemMaster" name="ns_item_master" class="mb-3" v-model="filterStatus" value="ns_item_master">
              NS Item Master
            </base-radio>
            <base-radio name="combined_master" class="mb-3" v-model="filterStatus" value="combined_master">
              Combined Master
            </base-radio>
            <base-radio name="alternate_barcode" class="mb-3" v-model="filterStatus" value="alternate_barcode">
              Alternate Barcode
            </base-radio>
          </div>
          <!-- Preserve mall-specific export format selection for possible future use.
          <div class="col-md-12" v-if="filterStatus == 'alternate_barcode'">
            <base-input label="Mall Group Format">
              <a-select showSearch v-model="inputMallGroup" optionFilterProp="children" style="width: 100%" :filterOption="filterOption" placeholder="Complete Template" allowClear>
                <a-select-option v-for="mallGroup in mallGroupOptions" :key="mallGroup.id" :value="mallGroup.id">
                  {{mallGroup.code}} - {{mallGroup.name}}
                </a-select-option>
              </a-select>
            </base-input>
          </div>
          -->
          <br/>
          <br/>
        </div>

        <div style="
                    position: absolute;
                    bottom: 0px;
                    right: 0px;
                    width: -webkit-fill-available;
                    background-color: #f2f2f2;
                    padding: 10px;
                  ">
          <a-spin tip="Exporting..." :spinning="spinningDownload">
            <button type="button" class="btn btn-primary float-right" :disabled="spinningDownload" @click.prevent="download">
              Export
            </button>
          </a-spin>
        </div>
        </div>

      <div v-if="profileAction == 'import_list' || profileAction == 'import_alternate_barcode_list'">
        <h6 class="heading-small text-muted mb-4">Import Options</h6>
        <div>
          <!-- Preserve mall-specific import override for possible future use.
          <div class="col-md-12 mb-3" v-if="profileAction == 'import_alternate_barcode_list'">
            <base-input label="Mall Group">
              <a-select showSearch v-model="inputMallGroup" optionFilterProp="children" style="width: 100%" :filterOption="filterOption" placeholder="Infer from uploaded format" allowClear>
                <a-select-option v-for="mallGroup in mallGroupOptions" :key="mallGroup.id" :value="mallGroup.id">
                  {{mallGroup.code}} - {{mallGroup.name}}
                </a-select-option>
              </a-select>
            </base-input>
          </div>
          -->
          <a-upload-dragger :remove="handleRemove" :fileList="fileList" :beforeUpload="beforeUpload" :multiple="false">
            <span class="fa fa-file-import" style="font: 20pt" />
            <p class="ant-upload-text">
              Click or drag file to this area to upload
            </p>
            <p class="ant-upload-hint">
              Upload your product list in a CSV file following the specified
              format. You can download download templates below.
              <br/>
              <span>Disclaimer: Can ignore price & cost on updating</span>
            </p>
          </a-upload-dragger>
          <!-- <button type="button" class="btn btn-primary float-right"></button> -->

          <br /><br />
          <a-collapse>
            <a-collapse-panel header="Templates" key="1">
              <a-list bordered>
                <template v-if="profileAction == 'import_list'">
                  <!-- <a-list-item v-if="enableAutoBarcodeAndStock">
                    <a-list-item-meta description="Contains required data to create a product without barcode and stock no">
                      <a @click.prevent="downloadTemplate('8')" slot="title">Download Item Master w/o Barcode and Stock No Template</a>
                    </a-list-item-meta>
                    <div>
                      <a @click.prevent="downloadTemplate('8')"><span class="fa fa-file-download" /></a>
                    </div>
                  </a-list-item> -->
                  <a-list-item>
                    <a-list-item-meta description="Contains required data to create a product">
                      <a @click.prevent="downloadTemplate('6')" slot="title">Download Item Master Template</a>
                    </a-list-item-meta>
                    <div>
                      <a @click.prevent="downloadTemplate('6')"><span class="fa fa-file-download" /></a>
                    </div>
                  </a-list-item>
                  <a-list-item>
                    <a-list-item-meta description="Contains required data to create a product with Ecom">
                      <a @click.prevent="downloadTemplate('7')" slot="title">Download Ecom Template</a>
                    </a-list-item-meta>
                    <div>
                      <a @click.prevent="downloadTemplate('7')"><span class="fa fa-file-download" /></a>
                    </div>
                  </a-list-item>
                </template>
                <template v-else>
                  <a-list-item>
                    <a-list-item-meta description="Contains required data for alternate barcode in Product">
                      <a @click.prevent="downloadTemplate('9')" slot="title">Download Alternate Barcode Template</a>
                    </a-list-item-meta>
                    <div>
                      <a @click.prevent="downloadTemplate('9')"><span class="fa fa-file-download" /></a>
                    </div>
                  </a-list-item>
                </template>

                <!-- <a-list-item>
                  <a-list-item-meta description="Includes matrix information about products">
                    <a @click.prevent="downloadTemplate('3')" slot="title">Download Matrix Product Template</a>
                  </a-list-item-meta>
                  <div>
                    <a @click.prevent="downloadTemplate('3')"><span class="fa fa-file-download" /></a>
                  </div>
                </a-list-item>
                <a-list-item>
                  <a-list-item-meta description="Contains required data to create a product with alternate supplier">
                    <a @click.prevent="downloadTemplate('4')" slot="title">Download Basic Product Template with Alternate Supplier</a>
                  </a-list-item-meta>
                  <div>
                    <a @click.prevent="downloadTemplate('4')"><span class="fa fa-file-download" /></a>
                  </div>
                </a-list-item> -->
              </a-list>
            </a-collapse-panel>
          </a-collapse>
        </div>

        <div style="
            position: absolute;
            bottom: 0px;
            right: 0px;
            width: -webkit-fill-available;
            background-color: #f2f2f2;
            padding: 10px;
          ">
          <a-spin :tip="spinMessage" :spinning="spinning">
            <button type="button" class="btn btn-primary float-right" @click.prevent="importFile(profileAction)">
              Import
            </button>
          </a-spin>
        </div>
      </div>

      <div v-if="profileAction == 'mass_import_list'">
        <h6 class="heading-small text-muted mb-4">Import Options</h6>
        <div>
          <a-upload-dragger :remove="handleRemove" :fileList="fileList" :beforeUpload="massbeforeUpload" :multiple="false">
            <span class="fa fa-file-import" style="font: 20pt" />
            <p class="ant-upload-text">
              Click or drag file to this area to upload
            </p>
            <p class="ant-upload-hint">
              Upload your product list in a CSV file following the specified
              format. You can download download templates below.
            </p>
          </a-upload-dragger>
          <!-- <button type="button" class="btn btn-primary float-right"></button> -->

          <br /><br />
          <a-collapse>
            <a-collapse-panel header="Templates" key="1">
              <a-list bordered>
                <a-list-item>
                  <a-list-item-meta description="Contains required data to create a product">
                    <a @click.prevent="downloadTemplate('5')" slot="title">Download Mass Update Product Template</a>
                  </a-list-item-meta>
                  <div>
                    <a @click.prevent="downloadTemplate('5')"><span class="fa fa-file-download" /></a>
                  </div>
                </a-list-item>
              </a-list>
            </a-collapse-panel>
          </a-collapse>
        </div>

        <div style="
            position: absolute;
            bottom: 0px;
            right: 0px;
            width: -webkit-fill-available;
            background-color: #f2f2f2;
            padding: 10px;
          ">
          <a-spin :tip="spinMessage" :spinning="spinning">
            <button type="button" class="btn btn-primary float-right" @click.prevent="importToProductList">
            Import
            </button>
          </a-spin>
        </div>
      </div>

      <div v-if="profileAction == 'print_list'">
        <h6 class="heading-small text-muted mb-4">Print Options</h6>
      </div>

      <div v-if="profileAction == 'configuration'">
        <h6 class="heading-small text-muted">Product Explorer Configuration</h6>
        <!-- {{settingsGrouping}} -->
        <base-alert v-if="errors.length" type="danger">
          <b>You have the following error(s):</b>
          <li v-for="error in errors" :key="error">{{ error }}</li>
        </base-alert>

        <dynamic-form :convertedJson="convertedJson" :formSettings="formSettings" @valueUpdated="updateSettings">
        </dynamic-form>

        <div class="float-right" style="position: absolute; bottom: 20px; right: 20px">
          <a-spin :tip="spinMessage" :spinning="spinning">
            <button class="btn btn-success" @click.prevent="processSettings">
              Save
            </button>
          </a-spin>
        </div>
      </div>
    </a-drawer>

    <a-drawer title="" :width="windowWidth" placement="right" @close="onClose" :visible="visible">
      <div>
        <product-form @closeDrawer="closeDrawer" v-on:refreshPage="refreshPage" :productType="productType"
          :btnValue="btnValue" :key="componentKey"></product-form>
      </div>
    </a-drawer>

    <a-drawer title="" :width="windowWidth" placement="right" @close="onClose" :visible="recipeVisible">
      <div>
        <recipe-form @closeDrawer="closeDrawer" @refreshPage="refreshPage" :key="recipeKey"></recipe-form>
      </div>
    </a-drawer>

    <div class="table-responsive">
      <!-- {{columns}} -->
      <div v-if="hasSelected" style="margin-bottom: 16px">
        <span style="margin-left: 20px">
          <template>
            <small>{{ `Selected ${selectedRowKeys.length} items` }}</small>
          </template>
        </span>
      </div>

      <div v-if="massUpdateMode == false || massUpdateMode == null">
        <a-table size="small" :rowSelection="{
          selectedRowKeys: selectedRowKeys,
          onChange: onSelectChange,
        }" :columns="columns" :dataSource="data" :scroll="scroll" :loading="loading" :rowKey="(record) => record.id"
          :pagination="pagination" @change="handleTableChange">
          <template slot="name" slot-scope="text, record">
            <a-tooltip>
              <template slot="title">
                {{ record.name }}
              </template>
              <img class="table-product-icons" :src="iconSourcePath(record.product_type)" alt="" />
              {{ _.truncate(record.name, { length: 22, omission: "..." }) }}
            </a-tooltip>
          </template>

          <template slot="status" slot-scope="status">
            {{ status | filterStatusOnTableList }}
          </template>

          <template slot="product_type" slot-scope="product_type">
            {{ product_type | filterProductTypeOnTableList }}
          </template>

          <template slot="action" slot-scope="action">
            <center>
              <a-dropdown>
                <a class="ant-dropdown-link" @click="e => e.preventDefault()">
                  <i class="fa fa-ellipsis-v"></i>
                </a>
                <a-menu slot="overlay">
                    <template v-if="massUpdateMode == false || massUpdateMode == null">
                      <template v-if="serverType == 'ho'">
                        <a-menu-item :key="1">
                          <button v-if="accessRights.includes('V')" class="btn btn-success btn-sm"
                            @click.prevent="showModal(action)">
                            History
                          </button>
                        </a-menu-item>
                        <a-menu-item :key="2">
                          <button v-if="accessRights.includes('V')" class="btn btn-info btn-sm" @click.prevent="
                            showDrawer(action.id, action.product_type, 1)
                          ">
                            View
                          </button>
                        </a-menu-item>
                        <a-menu-item :key="3">
                          <button v-if="accessRights.includes('W')" class="btn btn-warning btn-sm" @click.prevent="
                            showDrawer(action.id, action.product_type, 0)
                          ">
                            Edit
                          </button>
                        </a-menu-item>
                        <a-menu-item :key="4">
                          <a-popconfirm placement="right" :title="`You are about to delete this record? ${action.name}`" @confirm="deleteRow(action.id)"
                            okText="Delete" cancelText="Cancel" v-if="accessRights.includes('D')">
                            <button class="btn btn-danger btn-sm">Delete</button>
                          </a-popconfirm>
                        </a-menu-item>
                        <a-menu-item :key="5" v-if="action.product_type == 'M'">
                          <button v-if="accessRights.includes('W')" class="btn btn-secondary btn-sm" @click.prevent="
                            showChildrenProducts(action.id)
                          ">
                            Show Matrix Items
                          </button>
                        </a-menu-item>
                      </template>
                      <template v-else>
                        <a-menu-item>
                          <button class="btn btn-info btn-sm" @click.prevent="
                            showDrawer(action.id, action.product_type, 1)
                          ">
                            View
                          </button>
                        </a-menu-item>
                        <a-menu-item>
                          <button class="btn btn-success btn-sm" @click.prevent="showModal(action)">
                            History
                          </button>
                        </a-menu-item>
                      </template>
                   </template>
                    <template v-else>
                      <template v-if="serverType == 'ho'">
                        <a-menu-item v-if="!productListIds.includes(action.id)">
                          <button class="btn btn-success btn-sm" style="width: 60%"
                            @click.prevent="addToProductList(action, 0)">
                            Add
                          </button>
                        </a-menu-item>
                        <a-menu-item v-else>
                          <button  class="btn btn-default btn-sm" @click.prevent="addToProductList(action, 0)">
                            Undo
                          </button>
                        </a-menu-item>
                      </template>
                    </template>
                </a-menu>
              </a-dropdown>
            </center>
          </template>
        </a-table>
      </div>

      <div v-if="massUpdateMode == true">
        <a-table size="small" :columns="mass_update_columns" :dataSource="copyData" :scroll="scroll" :loading="loading"
          :rowKey="(record) => record.id" :pagination="pagination" @change="handleTableChange" :key="componentKey">
          <template slot="name" slot-scope="text, record">
            <a-tooltip>
              <template slot="title">
                {{ record.name }}
              </template>
              <img class="product-icons" :src="iconSourcePath(record.product_type)" alt="" />
              {{ _.truncate(record.name, { length: 22, omission: "..." }) }}
            </a-tooltip>
          </template>

          <template slot="status" slot-scope="status">
            {{ status | filterStatusOnTableList }}
          </template>
          <template slot="product_type" slot-scope="product_type">
            {{ product_type | filterProductTypeOnTableList }}
          </template>

          <template slot="action" slot-scope="action">
            <center>
              <div v-if="serverType == 'ho'" class="table-button-container">
                <button v-if="!productListIds.includes(action.id)" class="btn btn-success btn-sm" style="width: 60%"
                  @click.prevent="addToProductList(action, 0)">
                  Add
                </button>
                <button v-else class="btn btn-default btn-sm" @click.prevent="addToProductList(action, 0)">
                  Undo
                </button>
              </div>
            </center>
          </template>
        </a-table>
      </div>
    </div>

    <a-modal :key="componentModal" :visible="viewTestImportModal" width="100%" title="Basic Modal" @ok="handleOk" @cancel="handleClose">
      <template #footer>
        <a-button key="submit" type="primary" :loading="loading" @click="handleOk">Ok</a-button>
      </template>
      <products-test-importer :componentKey="componentModal"></products-test-importer>
    </a-modal>
  </div>
</template>

<script>
const columns = [
  {
    title: "",
    key: "operation",
    fixed: "left",
    align: "center",
    width: 5,
    scopedSlots: { customRender: "action" },
  },
  {
    title: "Name",
    width: 300,
    dataIndex: "name",
    key: "name",
    scopedSlots: { customRender: "name" },
  },
  {
    title: "Barcode",
    width: 200,
    dataIndex: "barcode",
    key: "barcode",
    width: 200,
  },
  {
    title: "Retail Price",
    dataIndex: "retail_price",
    key: "2",
    width: 100,
    align: "right",
  },
  // {
  //   title: "Site Retail Price",
  //   dataIndex: "site_retail_price",
  //   key: "1",
  //   width: 100,
  //   align: "right",
  // },
  // { title: 'Product Type', dataIndex: 'product_type', key: '2', width: 200, scopedSlots: { customRender: 'product_type' }},
  {
    title: "Status",
    dataIndex: "status",
    key: "3",
    width: 100,
    scopedSlots: { customRender: "status" },
    },
];
// Column ends here
// Mass update column
const mass_update_columns = [
  {
    title: "Name",
    width: 300,
    dataIndex: "name",
    key: "name",
    scopedSlots: { customRender: "name" },
  },
  {
    title: "Barcode",
    width: 200,
    dataIndex: "barcode",
    key: "barcode",
    width: 200,
  },
  {
    title: "Retail Price",
    dataIndex: "retail_price",
    key: "2",
    width: 100,
    align: "right",
  },
  // {
  //   title: "Site Retail Price",
  //   dataIndex: "site_retail_price",
  //   key: "1",
  //   width: 100,
  //   align: "right",
  // },
  // { title: 'Product Type', dataIndex: 'product_type', key: '2', width: 200, scopedSlots: { customRender: 'product_type' }},
  {
    title: "Status",
    dataIndex: "status",
    key: "3",
    width: 100,
    scopedSlots: { customRender: "status" },
  },
  {
    title: "Action",
    key: "operation",
    fixed: "right",
    align: "center",
    width: 300,
    scopedSlots: { customRender: "action" },
  }
];
// End Mass update column

import reqwest from "reqwest";
import axios from "axios";
import { mapState, mapActions } from "vuex";

import draggable from "vuedraggable";
import secureStorage from "../../controllers/secureStorage";
import HTTPRequest from "../../controllers/httpRequest.js";
import StockCard from "../Products/StockCard.vue";
import DynamicForm from "../DynamicForm.vue";
import ProductForm from "../Products/ProductForm";
import RecipeForm from "../Products/RecipeForm";
import ValidateField from "../../components/validateFormUtils.js";
import { compareData } from "../../utilities.js";
import moment from "moment";
import DocumentConfigurationHistory from "../Documents/DocumentConfigurationHistory.vue";
import ProductsTestImporter from "./ProductTestImporter.vue"

var ObjGen = require("../../../node_modules/objgen/objgen.js").ObjGen;

var component_x;

export default {
  components: {
    StockCard,
    ProductForm,
    DynamicForm,
    RecipeForm,
    draggable,
    DocumentConfigurationHistory,
    ProductsTestImporter
  },
  computed: {
    ...mapState([
      "currentProfile",
      "currentApiURL",
      "endPoint",
      "profileId",
      "parameters",
      "parentId",
      "serverType",
    ]),
    hasSelected() {
      return this.selectedRowKeys.length > 0;
    },
  },
  filters:{
    filterStatusOnTableList(value){
      if(value == 'A'){
        return 'Active';
      }else{
        return 'Inactive';
      }
    },
    filterProductTypeOnTableList(value){
      var productType = "";
      switch(value){
        case '':
          productType = "Regular";
          break;
        case 'P':
          productType = "Package";
          break;
        case 'N':
          productType = "Non-Inventory";
          break;
        case 'S':
          productType = "Serial";
          break;
        case 'K':
          productType = "Kit Item";
          break;
        case 'V':
          productType = "Virtual Kit";
          break;
        case 'M':
          productType = "Matrix";
          break;
        case 'B':
          productType = "Combo";
          break;
        case 'R':
          productType = "Recipe";
          break;
        default:
          productType = "Regular";
          break;
      }
      return productType;
    }
  },
  data() {
    return {
      mass_barcodes: [],
      icon_code: JSON.parse(localStorage.getItem("businessTypeCode")),
      spinMessage: 'Saving......',
      spinning: false,
      configHistoryVisible: false,
      modalVisible: false,
      rowSelection: {},
      selectedRowKeys: [],
      scroll: {},
      dragging: false,
      enabled: true,
      selectedProduct: null,
      warn_at_zero_price: false,
      warn_at_zero_cost: false,
      warn_at_price_below_cost: false,
      notif_zero_price: false,
      notif_zero_cost: false,
      notif_price_below_cost: false,
      enable_regular: false,
      enable_packaged: false,
      enable_matrix: false,
      enable_kit: false,
      enable_virtual_kit: false,
      enable_non_inventory: false,
      enable_serial: false,
      enable_recipe: false,
      enable_combo: false,
      enable_gift_certificate: false,
      default_display: 10,
      data: [],
      fields: [],
      columns: columns,
      mass_update_columns: mass_update_columns,
      pagination: {
        pageSize: 10,
      },
      currentPage: 1,
      site_type: "ho",
      site_id: "",
      loading: false,
      filterStatus: "item_master",
      profileAction: "",
      checkedFields: [],
      checkedItems: [],
      account_business_type: [],
      sorting_orders:["Update Date", "Product Name", "Barcode", "Stock Number"],
      selected_sorting_order:"",
      spinningDownload:false,


      // checkedFields: (secureStorage.getItem("productDefaultColumns") == null) ?
      //  ["name", "barcode", "retail_price", "status"] :
      //  secureStorage.getItem("productDefaultColumns"),

      availableFields: [],
      errorMessage: null,
      successMessage: null,
      componentKey: 0,
      drawerVisible: false,
      visible: false,
      recipeVisible: false,
      apiURL: "",
      type: null,
      filterField: "name",
      filterCaption: "Filter by Name",
      searchText: null,
      params: {},
      stockCardVisible: false,
      stockCardKey: 0,
      windowWidth: 0,
      convertedJson: null,
      convertedJson2: null,
      width: 500,
      isAdmin: false,
      formSettings: { isAdmin: false },
      settingsGrouping: {},
      draggableKey: 0,
      massUpdateMode: false,
      title: "Product List",
      productType: "",
      productList: [],
      productListIds: [],
      filterParams: {},
      tags: [],
      allowMultiple: false,
      fileList: [],
      errors: [],
      accessRights: [],
      copyData: [],
      recipeKey: 0,
      btnValue: 0,
      initialSettings: {},
      logSettings: {},
      diffSettings: [],
      sortParams:'',
      viewTestImportModal: false,
      componentModal:0,
      inputProductCreateDate: [moment().startOf('day'), moment().endOf('day')],
      inputProductUpdateDate: [],
      brandOptions: [],
      inputBrands: [],
      companyOptions: [],
      inputCompanies: [],
      categoryOptions: [],
      inputCategories: [],
      mallGroupOptions: [],
      inputMallGroup: null,
      dateFormat: "MM-DD-YYYY",
      customFields: [],
      itemFields: [],
      ecomFields: [],
      inputYearSeason: null,
      inputExportType: "piml",
      exportTypeOptions: [
        {code: "piml", name: "PIML"},
        {code: "ph_retail", name: "PH Retail"}
      ],
      inputStatus: "A",
      exportStatusOptions: [
        {code: "A", name: "Active"},
        {code: "I", name: "Inactive"},
        {code: "", name: "All"},
        {code: "D", name: "Deleted"}
      ],
      enableExportTypeFilter: false,
      enableAutoBarcodeAndStock: false,
      enableNsItemMaster: false
    };
  },
  watch: {
    selected_sorting_order: async function (){
      switch (this.selected_sorting_order) {
        case "Update Date":
            this.sortParams = "updated_at"
          break;
      
        case "Barcode":
            this.sortParams = "barcode"
          break;
      
        case "Stock Number":
            this.sortParams = "stock_no"
          break;
      
        default: "Product Name"
            this.sortParams = "name"
          break;
      }
      this.params = {...this.params, sort:this.sortParams}
      this.fetch(this.params)
    },
    currentApiURL: function () {
      this.apiURL = this.currentApiURL;
    },
    parameters: function () {
      this.apiURL = this.currentApiURL;
      this.apiURL = this.apiURL + this.parameters;
      this.$refs.vuetable.selectedTo = [];
      this.checkedItems = [];
    },
    massUpdateMode: function () {
      if (this.massUpdateMode == true) {
        this.title = "Mass Update Products";
      } else {
        this.title = "Product List";
      }
      this.componentKey++;
    },
    checkedFields: function () {
      if (!this.checkedFields.length) {
        this.$notification['warning']({
          message: 'Customized columns cannot be empty',
          description: 'Columns reset to default.',
          placement: 'bottomRight'
        })
        this.checkedFields = ["name", "barcode", "status"]
        // this.fields = ["__checkbox", "id", "code", "name", "status", "__slot:actions"]
      }
    },
  },

  mounted: async function () {
    component_x = this;
    this.accessRights = this.$attrs.accessRights;
    this.params = this.$attrs.params;
    this.massUpdateMode = this.$attrs.massUpdateMode;
    this.rowSelection = {
      selectedRowKeys: this.selectedRowKeys,
      onChange: this.onSelectChange,
    };

    // console.log("ProductsTableV2 : " + this.massUpdateMode)
    if (this.$attrs.filterParams != undefined) {
      this.filterParams = this.$attrs.filterParams;
    }

    if (this.$attrs.tags != undefined) {
      this.tags = this.$attrs.tags;
    }

    // on mount if localstorage exist add product to product list and product id to productlistid
    if (
      localStorage.productList &&
      component_x.params.productList == null &&
      component_x.massUpdateMode == true
    ) {
      component_x.productList = JSON.parse(localStorage.productList);
      var ids = component_x.productList.map(function (value) {
        return value.id;
      });
      component_x.productListIds = ids;
    }

    if (this.params.productList != undefined) {
      this.productList = this.params.productList;
      var ids = this.productList.map(function (value) {
        return value.id;
      });
      this.productListIds = ids;
    }

    if (this.params.massUpdateMode != undefined) {
      this.massUpdateMode = this.params.massUpdateMode;
    }

    if (this.params.tableParams != undefined) {
      this.params = this.params.tableParams;
    }

    await component_x.getBrandOptions();
    await component_x.getCategoryOptions();
    await component_x.getCompanyOptions();
    await component_x.getMallGroupOptions();

    var jsonField;
    jsonField = await HTTPRequest.getRequest(
      this.endPoint + "dynamic_forms/PXConfiguration?field_name=profile_name",
      null,
      null
    );
    this.convertedJson = ObjGen.xJson(jsonField.template, { numSpaces: 2 });

    //Parse Configuration
    //1960
    secureStorage.setItem("documentTypeId", -2);
    let congfigData = JSON.parse(this.convertedJson).groups
    for (let i = 0; i < congfigData.length; i++) {
      var group = JSON.parse(this.convertedJson).groups[i].name.replace(
        " ",
        ""
      );
      var subGroups = JSON.parse(this.convertedJson).groups[i].subGroups;
      for (let s = 0; s < subGroups.length; s++) {
        var groupName = group + '_' + JSON.parse(this.convertedJson).groups[i].subGroups[s].name
        var terminalSettings = JSON.parse(this.convertedJson).groups[i].subGroups[s].terminalSettings
        for (let t = 0; t < terminalSettings.length; t++) {
          let tS = JSON.parse(this.convertedJson).groups[i].subGroups[s]
            .terminalSettings[t];
          let tSN = tS.code != undefined ? tS.code : tS.header;
          let tSG = "groupName_" + (tS.code != undefined ? tS.code : tS.header);
          let tSV =
            tS.defaultValue != undefined
              ? tS.defaultValue
              : tS.type == "number"
                ? 0
                : tS.type == "boolean"
                  ? false
                  : "";
          var setting = [];
          if (tSN.includes("_")) setting.push({ [tSN]: tSV, [tSG]: groupName });
          this.initialSettings = Object.assign(
            this.initialSettings,
            setting[0]
          );
        }
      }
    }
    //Parse Configuration
    //1960

    this.site_id = secureStorage.getItem("defaultSiteId");

    let site = await HTTPRequest.getRequest(
      this.endPoint + "/sites/" + this.site_id,
      null
    );
    if (site != undefined) {
      this.site_type = site.site_type;
    }

    var userId = secureStorage.getItem("userId");
    var response;

    response = await HTTPRequest.getRequest(
      this.endPoint + "/user_settings?module_name=px&user_id=" + userId,
      null
    );
    var userSettings;
    if (response.data[0] != undefined) {

      userSettings = JSON.parse(response.data[0].settings_json);

      // sort data by selected option
      this.selected_sorting_order = this.sorting_orders[(userSettings.sorting_order - 1)]
      
    } else {
      userSettings = {};
    }
    response = await HTTPRequest.getRequest(
      this.endPoint + "/system_settings?module_name=px",
      null
    );
    var systemSettings;
    if (response.data[0] != undefined) {
      systemSettings = JSON.parse(response.data[0].settings_json);
    } else {
      systemSettings = {};
    }
    if(systemSettings && systemSettings["enable_auto_barcode_and_stock_no"] != null){
      this.enableAutoBarcodeAndStock = systemSettings["enable_auto_barcode_and_stock_no"]
    }

    if(systemSettings && systemSettings["enable_ns_item_master_template"]){
      this.enableNsItemMaster = systemSettings["enable_ns_item_master_template"]
    }

    let userSettingHashSite = {};
    userSettingHashSite["site_id"] = this.site_id;

    let site_response;
    site_response = await HTTPRequest.getRequest(
      this.endPoint +
      "/user_settings?module_name=site_product&user_id=" +
      userId,
      null
    );
    if (site_response.data.length == 0) {
      let createParams = {
        user_setting: {
          module_name: "site_product",
          user_id: userId,
          settings_json: JSON.stringify(userSettingHashSite),
        },
      };
      await HTTPRequest.postRequest(
        this.endPoint + "/user_settings",
        null,
        createParams
      );
    } else {
      let updateParams = {
        user_setting: {
          module_name: "site_product",
          user_id: userId,
          settings_json: JSON.stringify(userSettingHashSite),
        },
      };
      await HTTPRequest.putRequest(
        this.endPoint + "/user_settings/" + site_response.data[0].id,
        null,
        updateParams
      );
    }

    var mergedHash = Object.assign({}, systemSettings, userSettings);
    this.formSettings = mergedHash;
    var defaultValues = []
    Object.keys(mergedHash).forEach(function (key) { defaultValues.push(key) });
    for (var i = 0; i < defaultValues.length; i++) {
      this.initialSettings[defaultValues[i]] = this.formSettings[defaultValues[i]]
    }

    if (this.formSettings.default_display != undefined) {
      if (this.formSettings.default_display.trim() != "") {
        this.default_display = this.formSettings.default_display;
        this.initialSettings["default_display"] =
          this.formSettings.default_display;
        this.pagination.pageSize = Number(this.default_display);
      }
    }

    if (this.formSettings.enable_combo != undefined) {
      this.enable_combo = this.formSettings.enable_combo;
      this.initialSettings["enable_combo"] = this.formSettings.enable_combo;
    }

    if (this.formSettings.enable_regular != undefined) {
      this.enable_regular = this.formSettings.enable_regular;
      this.initialSettings["enable_regular"] = this.formSettings.enable_regular;
    }

    if (this.formSettings.enable_packaged != undefined) {
      this.enable_packaged = this.formSettings.enable_packaged;
      this.initialSettings["enable_packaged"] =
        this.formSettings.enable_packaged;
    }

    if (this.formSettings.enable_matrix != undefined) {
      this.enable_matrix = this.formSettings.enable_matrix;
      this.initialSettings["enable_matrix"] = this.formSettings.enable_matrix;
    }

    if (this.formSettings.enable_kit != undefined) {
      this.enable_kit = this.formSettings.enable_kit;
      this.initialSettings["enable_kit"] = this.formSettings.enable_kit;
    }

    if (this.formSettings.enable_virtual_kit != undefined) {
      this.enable_virtual_kit = this.formSettings.enable_virtual_kit;
      this.initialSettings["enable_virtual_kit"] =
        this.formSettings.enable_virtual_kit;
    }

    if (this.formSettings.enable_non_inventory != undefined) {
      this.enable_non_inventory = this.formSettings.enable_non_inventory;
      this.initialSettings["enable_non_inventory"] =
        this.formSettings.enable_non_inventory;
    }

    if (this.formSettings.enable_serial != undefined) {
      this.enable_serial = this.formSettings.enable_serial;
      this.initialSettings["enable_serial"] = this.formSettings.enable_serial;
    }

    if (this.formSettings.enable_recipe != undefined) {
      this.enable_recipe = this.formSettings.enable_recipe;
      this.initialSettings["enable_recipe"] = this.formSettings.enable_recipe;
    }

    if (this.formSettings.enable_gift_certificate != undefined) {
      this.enable_gift_certificate = this.formSettings.enable_gift_certificate;
      this.initialSettings["enable_gift_certificate"] = this.formSettings.enable_gift_certificate;
    }

    if (this.formSettings.warn_at_zero_cost != undefined) {
      this.warn_at_zero_cost = this.formSettings.warn_at_zero_cost;
      this.initialSettings["warn_at_zero_cost"] =
        this.formSettings.warn_at_zero_cost;
    }

    if (this.formSettings.warn_at_zero_price != undefined) {
      this.warn_at_zero_price = this.formSettings.warn_at_zero_price;
      this.initialSettings["warn_at_zero_price"] =
        this.formSettings.warn_at_zero_price;
    }

    if (this.formSettings.warn_at_price_below_cost != undefined) {
      this.warn_at_price_below_cost =
        this.formSettings.warn_at_price_below_cost;
      this.initialSettings["warn_at_price_below_cost"] =
        this.formSettings.warn_at_price_below_cost;
    }

    if(this.formSettings.enable_export_type_filter != undefined){
      this.enableExportTypeFilter = this.formSettings.enable_export_type_filter
      this.initialSettings["enable_export_type_filter"] = this.formSettings.enable_export_type_filter
    }

    if (
      this.warn_at_zero_cost == true ||
      this.warn_at_zero_price == true ||
      this.warn_at_price_below_cost == true
    ) {
      var zero_cost_data = await HTTPRequest.getRequest(
        component_x.endPoint + "products/get_zero_products",
        null
      );
      if (this.warn_at_zero_price == true) {
        if (
          zero_cost_data.zero_price_total > 0 &&
          component_x.notif_zero_price == false
        ) {
          this.$notification["warn"]({
            message: "Warning",
            description: "There are items with Zero Price.",
          });
          component_x.notif_zero_price = true;
        }
      }

      if (this.warn_at_zero_cost == true) {
        if (
          zero_cost_data.zero_cost_total > 0 &&
          component_x.notif_zero_cost == false
        ) {
          this.$notification["warn"]({
            message: "Warning",
            description: "There are items with Zero Cost.",
          });
          component_x.notif_zero_cost = true;
        }
      }

      if (this.warn_at_price_below_cost == true) {
        if (
          zero_cost_data.price_below_cost_total > 0 &&
          component_x.notif_price_below_cost == false
        ) {
          this.$notification["warn"]({
            message: "Warning",
            description: "The price of an item is below than cost/landed cost.",
          });
          component_x.notif_price_below_cost = true;
        }
      }
    }

      this.fetch(this.params);

    var response = await HTTPRequest.getRequest(
      this.endPoint + "products/get_viewable_fields",
      null
    );
    // console.log(response["fields"]);
    this.availableFields = response["fields"];

    // rename tax_type into vat_type
    var price_cost_fields = response["fields"];
    this.availableFields = this.availableFields.map((field) => {
      //Apply access cost & price
      if(field.match(/price.*/) && !this.accessRights.includes('Y')){
        price_cost_fields = price_cost_fields.filter(function(item) {
            return item !== field
        })
        //price_cost_fields.push(field)
      }
      if(field.match(/cost.*/) && !this.accessRights.includes('Z')){
        //price_cost_fields.push(field)
        price_cost_fields = price_cost_fields.filter(function(item) {
            return item !== field
        })
      }
      
      if (field == 'tax_type') {
        return 'vat_type';
      }else{
        return field;
      }
    })
    this.availableFields = price_cost_fields
    this.$nextTick(function () {
      //for fullscreen drawer
      window.addEventListener("resize", this.getWindowWidth);
      this.getWindowWidth();
    });
    // check on mount if localstorage productlist exisi -> then remove it
    this.clearProductListLocalStorage();

    let productsTableCustomList = localStorage.productsTableCustomList
    if (productsTableCustomList != undefined && productsTableCustomList != null) {
      this.columns = JSON.parse(productsTableCustomList)
    } else {
      this.columns = columns
    }

    // These lines will check for localStorage if there are existing checked fields if there's none, it will give default value
    let checkedfields = localStorage.checkedFields
    // console.log(checkedfields);
    if (checkedfields != undefined && checkedfields != null) {
      component_x.checkedFields = JSON.parse(checkedfields)
    } else {
      component_x.checkedFields = ["name", "barcode", "status"]
    }
    var mod = _.startCase(_.singularize(this.currentProfile))
    const sytemModule = await HTTPRequest.getRequest(
            this.endPoint + `system_modules/${mod}s?field_name=name`,
            null
        );
    const sytemModuleId = sytemModule.id;
    const accSystemModuleRequest = await HTTPRequest.getRequest(
        this.endPoint +
            "account_system_modules/" +
            sytemModuleId +
            "?field_name=system_module_id",
        null
    );
    if (this.isJsonString(accSystemModuleRequest.meta) == true) {
      const accSystemModule = JSON.parse(accSystemModuleRequest.meta);
        if (accSystemModule != null) {
            var customFields = []
            if (accSystemModule.form_mode != undefined) {
                customFields = accSystemModule.customized_fields; 
                
                if(customFields != undefined){
                    this.customFields = customFields.map(item => item.code);
                }
                
                let customForm = accSystemModule.customized_forms.groups_append
                if(customForm != undefined){
                  // check in udf header if its item_master
                  // console.log(customForm)
                  let productStatusObject = customForm.filter(item => item.name === 'Item Master' || item.name === 'Item Master Attributes' || item.name === 'Manufacturer Details' || item.name === 'Manufacturer' || item.name === 'Other Pricing' || item.name === 'Other Prices/Currencies');
                  // Check if any matching items were found
                  if (productStatusObject.length > 0) {
                    this.itemFields = []
                    // Loop through each found item
                    productStatusObject.forEach(item => {
                        // console.log("WOW",item)
                          // Map the code property of each terminal setting
                          let terminalSettingsCodes = item.terminalSettings.map(setting => setting.code);
                          // Assign the mapped codes to this.itemFields
                          this.itemFields.push(...terminalSettingsCodes);
                      });
                  }
                  // console.log(this.itemFields)

                  let productStatusObject2 = customForm.filter(item => item.name === 'Ecom Master Attributes' || item.name === 'Ecom Master' || item.name === 'Packaging' || item.name === 'Other Details' || item.name === 'Channel Specific - Hedgren' || item.name === 'Channel Specific - Tumi');
                  if (productStatusObject2.length > 0){
                    this.ecomFields = []
                    productStatusObject2.forEach(item => {
                          // Map the code property of each terminal setting
                          let terminalSettingsCodes = item.terminalSettings.map(setting => setting.code);
                          // Assign the mapped codes to this.itemFields
                          this.ecomFields.push(...terminalSettingsCodes);
                    });
                  }
                }


            }
        }
    }

    this.scroll = { x: 200 * this.checkedFields.length + 300, y: 500 };
    // it ends here


  },
  beforeDestroy() {
    //for fullscreen drawer
    window.removeEventListener("resize", this.getWindowWidth);
  },

  destroyed: async function () {
    // console.log(this.$route)
    localStorage.removeItem("productList");
    // if productlist exist and route is still product explorer add to local storage
    if (this.productList.length > 0 && this.$route.name == "product explorer") {
      localStorage.setItem("productList", JSON.stringify(this.productList));
    }
  },
  methods: {
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
    isJsonString(str) {
      try {
          var json = JSON.parse(str);
          return typeof json === "object";
      } catch (e) {
          return false;
      }
    },
    async getBrandOptions() {
      var brands = await HTTPRequest.getRequest(
          this.endPoint + "/brands/get_valid_brands?mode=all",
          null,
          null
      );
      // brands.unshift({code: null, id: null, name: '' })
      this.brandOptions = brands;
      
    },

    async getCompanyOptions() {
      var companies = await HTTPRequest.getRequest(
          this.endPoint + "/companies/get_valid_companies?mode=all",
          null,
          null
      );
      // brands.unshift({code: null, id: null, name: '' })
      this.companyOptions = companies;
    },

    async getCategoryOptions(){
      var categories = await HTTPRequest.getRequest(
        this.endPoint + "/categories/get_valid_categories?level=1",
        null,
        null
      )

      this.categoryOptions = categories;
    },

    async getMallGroupOptions(){
      var mallGroups = await HTTPRequest.getRequest(this.endPoint + "/mall_groups?per_page=500", null, null);

      this.mallGroupOptions = mallGroups.data || [];
    },

    updateProductCreateDate(date){
      if(date != null){
        this.inputProductCreateDate = moment(date).format("MMMM DD, YYYY");
      }
    },

    updateProductUpdateDate(date){
      if(date != null){
        this.inputProductUpdateDate = moment(date).format("MMMM DD, YYYY");
      }
    },

    // clear local storage produclist
    clearProductListLocalStorage() {
      if (localStorage.productList) {
        localStorage.removeItem("productList");
      }
    },
    async importFile(profileAction) {
      if (this.fileList.length == 0) {
        this.$notification["error"]({
          message: "Upload Failed",
          description: "Please select a CSV file.",
        });
        return;
      }

      this.spinning = true
      let importType = 'products' 
      if(profileAction == 'import_alternate_barcode_list'){
        importType = 'product_barcodes'
      }
      let formData = new FormData();
      formData.append("profile_name", importType);
      formData.append("file", this.fileList[0]);
      await axios({
        method: "post",
        url: this.endPoint + "importers/upload_file",
        headers: {
          Authorization: "Bearer " + secureStorage.getItem("accessToken"),
          "Access-Control-Allow-Origin": "*", 'Request-Source':"BXI-File", 'ip':secureStorage.getItem("ipAddress") 
        },
        data: formData,
      }).then(async function (m) {
        if (!m.data.file_name) {
          component_x.$notification["error"]({
            message: "Upload Failed",
            description: m.data.error || "The CSV file could not be uploaded.",
          });
          component_x.spinning = false;
          return;
        }

        // alert(m.data.file_name)
        var payload = {
          import_job: { profile_name: importType, file_name: m.data.file_name },
        };
        if (profileAction == 'import_alternate_barcode_list' && component_x.inputMallGroup) {
          payload.mall_group_id = component_x.inputMallGroup;
        }
        var response = await HTTPRequest.postRequest(
          component_x.endPoint + "/import_jobs",
          null,
          payload
        );
        if (response.id != null) {
          component_x.$notification["success"]({
            message: "Successful Operation",
            description:
              "File has been uploaded. Your importation is ongoing, you can check the ongoing jobs for updates.",
            btn: (h) => {
              return h(
                "base-button",
                {
                  props: {
                    type: "primary",
                    class: "btn-sm",
                  },
                  on: {
                    click: () => component_x.$router.push("/jobs"),
                  },
                },
                "View Jobs"
              );
            },
          });
          component_x.drawerVisible = false;
        }
        // console.log(response)
        component_x.spinning = false
      }).catch(function (error) {
        component_x.$notification["error"]({
          message: "Upload Failed",
          description:
            (error.response && error.response.data && error.response.data.error) ||
            "Please upload a valid CSV file.",
        });
        component_x.spinning = false;
      });
      // .catch(function () {
      //     alert("NOT OKAY")
      // });
    },
    async massupdate(field_name, value) {
      var field_update = {};
      this.modalVisible = false;
      field_update[field_name] = value;
      var payload = {
        ids: this.selectedRowKeys,
        field_update: field_update,
      };
      var response = await HTTPRequest.postRequest(
        this.endPoint + "products/mass_update",
        null,
        payload
      );
      if (response["message"] == "Ok") {
        this.$notification["success"]({
          message: "Update Successful",
          description: field_name == 'status' ? "Selected product successfully updated" : "Mass update of selected product suceeded.",
        });
        this.fetch(this.params);
        this.selectedRowKeys = [];
      } else {
        this.$notification["error"]({
          message: "Update Failed",
          description:
            "Mass update of selected product failed. " + response["error"],
        });
      }
    },
    handleRemove(file) {
      const index = this.fileList.indexOf(file);
      const newFileList = this.fileList.slice();
      newFileList.splice(index, 1);
      this.fileList = newFileList;
    },
    beforeUpload(file) {
      const extension = file.name.split(".").pop().toLowerCase();
      if (extension != "csv") {
        this.$notification["error"]({
          message: "Unsupported File",
          description: "Please upload a CSV file. Apple Numbers and Excel files are not supported.",
        });
        this.fileList = [];
        return false;
      }

      this.fileList = [file];
      return false;
    },
    massbeforeUpload(file) {
      this.fileList = [];
        const reader = new FileReader();
        reader.onload = async e => {
          this.mass_barcodes = []
          var text = e.target.result;
          var lines = text.split(/[\r\n]+/g); // tolerate both Windows and Unix linebreaks
          for(var i = 1; i < lines.length; i++) {
            if (lines[i].split(',')[0] !=null && lines[i].split(',')[0] !="" && lines[i].split(',')[0]!=undefined){
              this.mass_barcodes.push(lines[i].split(',')[0])
            }
          }
        }
        reader.readAsText(file);
      this.fileList = [...this.fileList, file];
      this.spinning = false;
      return false;
    },
    onSelectChange(selectedRowKeys) {
      // console.log('selectedRowKeys changed: ', selectedRowKeys);
      this.selectedRowKeys = selectedRowKeys;
    },
    async showMassUpdater() {
      this.productList.forEach((product) => {
        if (product.product_type == "M") {
          axios({
            method: "GET",
            url:
              this.endPoint +
              "products/get_matrix_items?matrix_parent_id=" +
              product.id +
              "&mass_update=true",
            headers: {
              Authorization: "Bearer " + secureStorage.getItem("accessToken"),
              "Access-Control-Allow-Origin": "*", 'Request-Source':"BXI-Web", 'ip':secureStorage.getItem("ipAddress") 
            },
          }).then((response) => {
            if (response.data.length >= 1) {
              product.children = response.data;
            }
          });
        }
        return product;
      });

      this.$router.push({
        name: "product_updates",
        params: {
          productList: this.productList,
          tableParams: this.params,
          filterParams: this.filterParams,
          tags: this.tags,
        },
      });
    },
    addToProductList(id, action) {
      if (this.productListIds.includes(id.id) && action == 0) {
          var indexValue = this.productListIds.indexOf(id.id);
          this.productList.splice(indexValue, 1);
      } else {
        this.productList.push({ id: id.id, name: id.name, barcode: id.barcode, stock_no: id.stock_no, product_type: id.product_type, product_grade_level: id.product_grade_level, product_group: { name: (id.product_group == null) ? null : id.product_group.name } });
        // console.log("ewan 2")
      }
      var ids = this.productList.map(function (value) {
        return value.id;
      });
      console.log(ids)
      this.productListIds = ids;
    },
    async importToProductList() {
      this.spinning = true;
      this.spinMessage = 'Importing ...'
      //Clear 
      this.productListIds = []
      this.productList = []
      if(this.mass_barcodes.length <=0){
        this.$notification["error"]({
          message: "Danger",
          description: "No Item Selected.",
        });
      } else {
        //Retrieve product details
        const mass_param = "barcodes="+this.mass_barcodes+"&search_via=barcode&"
        var barcodeDetails = await HTTPRequest.getRequest(`${component_x.endPoint}products/get_mass_products?${mass_param}per_page=9999999&page=1`, null);
        this.productList = barcodeDetails.products || [];
        if(this.productList.length <=0){
          this.$notification["error"]({
            message: "Danger",
            description: "No Item Selected.",
          });
        } else {
          var ids = this.productList.map(function (value) {
            return value.id;
          });
          this.productListIds = ids;
          this.spinning = false;
          component_x.drawerVisible = false;
          this.$notification["success"]({
              message: "Success",
              description: "Items has been imported.",
          });
        }
      }
    },
    // select all function
    changeMode() {
      this.massUpdateMode = !this.massUpdateMode;
      if (this.massUpdateMode == true) {
        this.$notification["info"]({
          message: "Note",
          description: "Click Add to include product in the Update List",
        });
      } else {
        // secureStorage.deleteItem("productList")
        this.productList = [];
        this.massUpdateMode = false;
        this.productListIds = [];
        this.params = "";
      }
      this.$emit(
        "changeMode",
        this.massUpdateMode,
        this.productList,
        this.params
      );
    },

    resetFields(){
      this.checkedFields = ["name", "barcode", "status"]
      this.updateTableList()
    },

    updateTableList() {
      var reference_array = this.availableFields;
      var array = this.checkedFields;
      if (array.length) {
        array.sort(function (a, b) {
          return reference_array.indexOf(a) - reference_array.indexOf(b);
        });
        this.checkedFields = array;
      } else {
        this.checkedFields = ["name", "barcode", "status"];
        this.$notification['warning']({
          message: 'Customized columns cannot be empty',
          description: 'Columns reset to default.'
        })
      }

      // secureStorage.setItem("productDefaultColumns", array);

      this.scroll = { x: 200 * array.length + 300, y: 500 };

      var updatedColumns = [];
      for (var i = 0; i < this.checkedFields.length; i++) {
        var title;
        var column;
        title = _.startCase(this.checkedFields[i]);
        var derived_values = [
          "category_name",
          "section_name",
          "department_name",
          "division_name",
        ];
        var valueToDisplay = this.checkedFields[i];
        // if (derived_values.includes(this.checkedFields[i])) {
        //   valueToDisplay = "category_tree['" + this.checkedFields[i] + "']";
        // }
        if (i == 0) {
          column = {
            title: title,
            width: 200,
            dataIndex: valueToDisplay,
            key: this.checkedFields[i],
            fixed: "left",
            scopedSlots: { customRender: "name" }
          };
        } else {
          if(valueToDisplay == 'status'){
            column = {
            title: title,
            dataIndex: valueToDisplay,
            key: this.checkedFields[i],
            width: 200,
            scopedSlots: { customRender: "status" }
            };
          } else if(valueToDisplay == 'product_type'){
            column = {
            title: title,
            dataIndex: valueToDisplay,
            key: this.checkedFields[i],
            width: 200,
            scopedSlots: { customRender: "product_type" }
            };
          }else if(valueToDisplay == 'vat_type'){
            column = {
              title: 'Vat Type',
              dataIndex: 'tax_type',
              key: 'tax_type',
              width: 200,
              };
          }else{
            column = {
              title: title,
              dataIndex: valueToDisplay,
              key: this.checkedFields[i],
              width: 200,
            };
          }
        }
        updatedColumns.push(column);
      }

      var actionColumn = {
        title: "Action",
        key: "operation",
        fixed: "right",
        width: 300,
        scopedSlots: { customRender: "action" },
      };
      updatedColumns.push(actionColumn);
      this.columns = updatedColumns;
      localStorage.setItem("checkedFields", JSON.stringify(this.checkedFields));
      localStorage.setItem("productsTableCustomList", JSON.stringify(updatedColumns));
      this.onClose();
    },
    showModal(product) {
      this.stockCardVisible = true;
      this.selectedProduct = product.id;
      this.stockCardKey++;
    },
    filterProducts() {
      this.params[this.filterField] = this.searchText;
      this.fetch(this.params);
    },
    changeFilter(field) {
      this.filterField = field;
      this.filterCaption = "Filter By " + _.startCase(this.filterField);
    },
    handleTableChange(pagination, filters, sorter) {
      filters = this.params;
      var pager = { ...this.pagination };
      pager.current = pagination.current;
      pager.pageSize = Number(this.default_display);
      this.pagination = pager;
      this.currentPage = pagination.current;
      this.fetch({
        results: Number(this.default_display),
        page: pagination.current,
        ...filters,
      });
    },
    fetch(params = {}) {
      this.loading = true;
      let additional_product_params = "";
      let siteId = secureStorage.getItem("defaultSiteId");
      additional_product_params = `&site_id=${this.site_id}&sort=${this.sortParams}`
      let userBrandLevel = secureStorage.getItem("userBrandLevel");
      if (userBrandLevel) {
        additional_product_params += `&userBrands=${userBrandLevel}`;
      }

      reqwest({
        url:
          this.endPoint +
          "products?per_page=" +
          this.default_display +
          "&all=1" +
          additional_product_params,
        method: "get",
        headers: {
          Authorization: "Bearer " + secureStorage.getItem("accessToken"),
          "Access-Control-Allow-Origin": "*", 'Request-Source':"BXI-Web", 'ip':secureStorage.getItem("ipAddress") 
        },
        data: {
          results: Number(this.default_display),
          mass_update_mode:this.massUpdateMode,
          userBrands: userBrandLevel,
          ...params
        },
      }).then((response) => {
        var pagination = { ...this.pagination };
        pagination.total = response.total;
        pagination.pageSize = Number(this.default_display);
        var productData = response.data;
        this.data = productData.slice(0);
        this.data.forEach((product) => {
          let retail_price = Number(product.retail_price);
          let site_retail_price = Number(product.site_retail_price);
          
          product.site_retail_price = site_retail_price
            .toFixed(2)
            .replace(/\d(?=(\d{3})+\.)/g, "$&,");
          product.retail_price = retail_price
            .toFixed(2)
            .replace(/\d(?=(\d{3})+\.)/g, "$&,");
          product.created_at = moment(product.created_at , "YYYY-MM-DD").format("MM-DD-YYYY")
          product.updated_at = moment(product.updated_at , "YYYY-MM-DD").format("MM-DD-YYYY")

          });
        var copyData = JSON.parse(JSON.stringify(productData));
        // productData.forEach(function(v) { copyData.push(v) });
        // this.copyData = productData.slice(0);
        // var productDataCopy = [...productData]
        copyData.map(function (item) {
          delete item.children;
          return item;
        });
          
          this.copyData = copyData;
        this.loading = false;
        this.pagination = pagination;

        })
    },
    addAllProduct() {
      let products = this.copyData;
      // console.log(products)
      products.forEach((product) => {
        this.addToProductList(product, 1);
      });
    },
    removeAllProduct() {
      this.productListIds = []
      this.productList = []
    },
    ...mapActions(["updateProfileId", "updateParentId"]),
    getWindowWidth(event) {
      //for fullscreen drawer
      this.windowWidth = window.innerWidth;
    },
    closeDrawer() {
      this.onClose();
    },
    refreshPage(event, action="") {
      this.onClose();
      this.successMessage = "Successful Operation";
      this.errorMessage = null;

      if(action === 'update'){
        var payload = {
          results: Number(this.default_display),
          page: this.currentPage,
          ...this.params
        }   
        this.fetch(payload);
      }else{
        this.fetch(this.params);
      }
      
    },
    onRowClick(dataItem) {
      this.updateParentId(dataItem.id);
    },
    onRowClass(dataItem) {
      return dataItem.id == this.parentId ? "table-success" : "";
    },
    showDrawer(id, type, btn) {
      this.btnValue = btn;
      if (type == "R") {
        this.recipeKey++;
        this.updateProfileId(id);
        this.productType = "R";
        this.recipeVisible = true;
      } else {
        this.componentKey++;
        this.updateProfileId(id);
        this.productType = type;
        this.visible = true;
      }
    },
    showRecipeDrawer(id) {
      this.recipeKey++;
      this.updateProfileId(id);
      this.productType = "R";
      this.recipeVisible = true;
    },
    updateSettings(formSettings, settingsGrouping) {
      this.formSettings = formSettings;
      this.settingsGrouping = settingsGrouping;
    },
    validateConfig(userSettings, globalSettings) {
      this.errors = [];
      if (
        globalSettings.short_name_length != undefined &&
        globalSettings.short_name_length != ""
      ) {
        if (globalSettings.short_name_length < 1) {
          this.errors.push("Lenght of Short Name must be greater than zero");
        } else if (globalSettings.short_name_length > 50) {
          this.errors.push(
            "Lenght of Short Name must be less than or equal to 50"
          );
        }
      }

      if (
        userSettings.default_markup != undefined &&
        userSettings.default_markup != ""
      ) {
        this.errors.push(
          ValidateField.requiredButAllowZero(
            "Markup Percent",
            userSettings.default_markup
          )
        );
      }

      if (
        userSettings.default_vat_rate != undefined &&
        userSettings.default_vat_rate != ""
      ) {
        this.errors.push(
          ValidateField.greaterThanZero(
            "VAT Rate Percent",
            userSettings.default_vat_rate
          )
        );
      }

      if (
        userSettings.markup_roundup != undefined &&
        userSettings.markup_roundup != ""
      ) {
        this.errors.push(
          ValidateField.greaterThanZero(
            "Roundup To",
            userSettings.markup_roundup
          )
        );
      }

      if (
        userSettings.default_display != undefined &&
        userSettings.default_display != ""
      ) {
        this.errors.push(
          ValidateField.greaterThanZero(
            "No. of Lines",
            userSettings.default_display
          )
        );
        this.errors.push(
          ValidateField.wholeNumberFormat(
            "No. of Lines",
            userSettings.default_display
          )
        );
      }

      document.getElementsByClassName(
        "ant-drawer-wrapper-body"
      )[0].scrollTop = 0;
      this.errors = this._.compact(this.errors);
      return this.errors.length;
    },
    async processSettings() {
      this.spinning = true;
      var userSettings = this.settingsGrouping["User Settings"];
      var globalSettings = this.settingsGrouping["Global Settings"];
      var userSettingHash = {};
      var globalSettingHash = {};
      var formSettings = this.formSettings;
      var initialSettings = this.initialSettings
      var endPoint = this.endPoint

      Object.keys(formSettings).forEach(function (key) {
        var value = formSettings[key];
        if (userSettings.includes(key)) {
          userSettingHash[key] = value;
        }
        if (globalSettings.includes(key)) {
          globalSettingHash[key] = value;
        }

        //1960
        if (Object.keys(initialSettings).includes(key) && value != initialSettings[key]) {

          var configHistoryPayload = {
            config: initialSettings['groupName_' + key],
            config_type: key,
            config_from: initialSettings[key],
            config_to: value,
            config_at: moment(new Date()),
            config_by: secureStorage.getItem("userName"),
            config_account: secureStorage.getItem("accountId"),
            document_type: -2
          }
          // Save config changes
          HTTPRequest.postRequest(
            endPoint + "document_configuration_histories/",
            null,
            configHistoryPayload
          );
          initialSettings[key] = value;
        }
      });
      this.initialSettings = initialSettings

      if (!this.validateConfig(userSettingHash, globalSettingHash)) {
        var userId = secureStorage.getItem("userId");
        var response;
        response = await HTTPRequest.getRequest(
          this.endPoint + "/user_settings?module_name=px&user_id=" + userId,
          null
        );
        if (response.data.length == 0) {
          var createParams = {
            user_setting: {
              module_name: "px",
              user_id: userId,
              settings_json: JSON.stringify(userSettingHash),
            },
          };
          await HTTPRequest.postRequest(
            this.endPoint + "/user_settings",
            null,
            createParams
          );
        } else {
          var updateParams = {
            user_setting: {
              module_name: "px",
              user_id: userId,
              settings_json: JSON.stringify(userSettingHash),
            },
          };
          await HTTPRequest.putRequest(
            this.endPoint + "/user_settings/" + response.data[0].id,
            null,
            updateParams
          );

          // update the selected sorting method
          let { user_setting: { settings_json } } = updateParams
          this.selected_sorting_order = this.sorting_orders[(JSON.parse(settings_json).sorting_order - 1)]
        }

        response = await HTTPRequest.getRequest(
          this.endPoint + "/system_settings?module_name=px",
          null
        );
        if (response.data.length == 0) {
          var createParams2 = {
            system_setting: {
              module_name: "px",
              settings_json: JSON.stringify(globalSettingHash),
            },
          };
          await HTTPRequest.postRequest(
            this.endPoint + "/system_settings",
            null,
            createParams2
          );
        } else {
          var updateParams2 = {
            system_setting: {
              module_name: "px",
              settings_json: JSON.stringify(globalSettingHash),
            },
          };
          await HTTPRequest.putRequest(
            this.endPoint + "/system_settings/" + response.data[0].id,
            null,
            updateParams2
          );
        }
        component_x.$notification["success"]({
            message: "Configuration has been saved",
            description:
              "Please refresh page for changes to take effect.",
          });
        this.closeDrawer();
      }
      this.spinning = false;
    },
    async showActionDrawer(action) {
      // bryan
      if (action == "customize_list") {
        // var response = await HTTPRequest.getRequest(this.endPoint + "products/get_viewable_fields",null)
        // this.availableFields = response["fields"]
        if (this.checkedFields.length == 0) {
          this.checkedFields = ["name", "barcode", "status"];
        }
      }

      if (action == "configuration") {
        this.width = 800;
        var userId = secureStorage.getItem("userId");
        var userGroupIds = await HTTPRequest.getRequest(
          this.endPoint + "users/show_user_memberships/?user_id=" + userId,
          null
        );
        var adminGroup = await HTTPRequest.getRequest(
          this.endPoint + "user_groups/Admin?field_name=name",
          null
        );
        if (userGroupIds.user_membership_ids.includes(adminGroup.id)) {
          this.isAdmin = true;
          this.formSettings.isAdmin = this.isAdmin;
        }
      } else if (action == "configurationhist") {
        this.configHistoryVisible = true
        this.width = 1100;
      } else {
        this.width = 500;
      }

      this.profileAction = action;
      this.drawerVisible = true;
    },
    onClose() {
      this.recipeVisible = false;
      this.drawerVisible = false;
      this.visible = false;
      this.componentKey++;
      this.recipeKey++;
    },
    log() {
      this.checkedItems = this.$refs.vuetable.selectedTo;
    },
    onCheckField(fieldName) {
      if (this.checkedFields.includes(fieldName)) {
        var indexValue = this.checkedFields.indexOf(fieldName);
        if (indexValue > -1) {
          this.checkedFields.splice(indexValue, 1);
        }
      } else {
        this.checkedFields.push(fieldName);
      }
    },
    onCheckAllField() {
      if (this.checkedFields.length == this.availableFields.length) {
        this.checkedFields = [];
      } else {
        this.checkedFields = Array.from(this.availableFields);
      }
    },
    onPaginationData(paginationData) {
      this.$refs.pagination.setPaginationData(paginationData);
    },
    async onLoadError(error) {
      // request for new token or reauthenticate
      if (error.response.status == 401) {
        var auth_response = await HTTPRequest.authenticate(
          component_x.endPoint
        );
        if (auth_response["status"] == "Ok") {
          this.$router.go();
        } else {
          alert("Cannot get access token. Please login again.");
          this.$router.push("/");
        }
      }
    },
    onChangePage(page) {
      this.$refs.vuetable.changePage(page);
    },
    deleteRow(id) {
      axios({
        method: "delete",
        url: this.endPoint + this.currentProfile + "/" + id,
        headers: {
          Authorization: "Bearer " + secureStorage.getItem("accessToken"),
          "Access-Control-Allow-Origin": "*", 'Request-Source':"BXI-Web", 'ip':secureStorage.getItem("ipAddress") 
        },
      })
        .then(function () {
          component_x.successMessage = "Successfully deleted record";
          component_x.fetch(component_x.params);
        })
        .catch((error) => {
          if (error.response) {
            component_x.errorMessage = error.response.data.error;
          } else {
            alert("Invalid Credentials");
          }
        });
    },
    downloadTemplate(type) {

      var customfield = ''
      if(this.customFields.length > 0){
          customfield = this.customFields.join(",")
      }

      if(type == "6" || type == "8"){
        // use itemFields instead of customFields
        if(this.itemFields != null && this.itemFields != undefined && this.itemFields != []){
          customfield = this.itemFields.join(",")
        }
      }else if(type == "7"){
        // check if ecom
        if(this.ecomFields != null && this.ecomFields != undefined && this.ecomFields != []){
          customfield = this.ecomFields.join(",")
        }
      }else if (type == "9"){
        customfield = []
      }

      var urlDownload;
      if (type == "1")
        urlDownload =
          this.endPoint +
          "import_templates/download_file?profile_name=products&type=basic";
      else if(type == "2")
        urlDownload =
          this.endPoint +
          "import_templates/download_file?profile_name=products&type=advanced";
      else if (type == "3")
        urlDownload =
          this.endPoint +
          "import_templates/download_file?profile_name=products&type=matrix";
      else if (type == "5")
        urlDownload =
          this.endPoint +
          "import_templates/download_file?profile_name=products&type=mass_update";
      else if (type == "6")
        urlDownload =
          this.endPoint +
          "import_templates/download_file?profile_name=products&type=primer&product_type=item";
      else if (type == "7")
        urlDownload =
          this.endPoint +
          "import_templates/download_file?profile_name=products&type=primer&product_type=ecom";
      else if (type == "8")
        urlDownload =
          this.endPoint +
          "import_templates/download_file?profile_name=products&type=primer&product_type=item_no_barstock";
      else if(type == "9")
        urlDownload = 
          this.endPoint +
            "import_templates/download_file?profile_name=products&type=primer&product_type=alternate_barcode";
      else
      urlDownload =
          this.endPoint +
          "import_templates/download_file?profile_name=products&type=basic_with_alternate_supplier";
      axios({
        url: urlDownload,
        method: "POST",
        responseType: "blob", // important
        headers: {
          Authorization: "Bearer " + secureStorage.getItem("accessToken"),
          "Access-Control-Allow-Origin": "*", 'Request-Source':"BXI-File", 'ip':secureStorage.getItem("ipAddress") 
        },
        data: {
            custom_field: customfield
        },
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        if(type == "6"){
          link.setAttribute("download", "item_master_template.csv");
        }else if(type == "7"){
          link.setAttribute("download", "ecom_master_template.csv");
        }else if(type == "8"){
          link.setAttribute("download", "item_master_no_barstock_template.csv");
        }else if(type == "9"){
          link.setAttribute("download", "alternate_barcode_template.csv");
        }else{
          link.setAttribute("download", "product_import_template.csv");
        }
        document.body.appendChild(link);
        link.click();
        component_x.$notification["success"]({
          message: "Successful Download",
          description:
            "You have succesfully downloaded the template for product upload.",
        });
      });
    },
    async download() {
      this.spinningDownload = true
      var payload = {};
      var additional_parameters = "";
      var baseUrl =
        this.endPoint + "products/download?file_type=csv&action_type=export";
      if (this.filterStatus == "0") {
        // All
        payload["type"] = "all";
      } else if (this.filterStatus == "2") {
        // Selected
        payload["type"] = "selected";
        payload["ids"] = this.selectedRowKeys;
      } else if (this.filterStatus == "3") {
        // Filtered
        payload["type"] = "filtered";
        var obj3 = Object.assign({}, payload, this.params);
        payload = obj3;
      } else if (this.filterStatus == "4") {
        // Site Products Only
        payload["type"] = "site_products_only";
        payload["site_id"] = this.site_id;
      } else if (this.filterStatus == "5") {
        // All Site Products
        payload["type"] = "all_site_products"; 
      } else if (this.filterStatus == 'item_master' || this.filterStatus == 'ecom_master' || this.filterStatus == 'combined_master' || this.filterStatus == 'ns_item_master' || this.filterStatus == 'alternate_barcode'){
        var customfield = ''
        if(this.customFields.length > 0){
            customfield = this.customFields.join(",")
        }

        if(this.filterStatus == "item_master"){
          // use itemFields instead of customFields
          // check in udf header if its item_master
          if(this.itemFields != null && this.itemFields != undefined && this.itemFields != []){
            customfield = this.itemFields.join(",")
          }
        }else if(this.filterStatus == "ecom_master"){
          // check if ecom
          if(this.ecomFields != null && this.ecomFields != undefined && this.ecomFields != []){
            customfield = this.ecomFields.join(",")
          }
        }

        if(this.inputBrands != null && this.inputBrands != "" && this.inputBrands != []){
          payload["brand_id"] = this.inputBrands;
        }
        if(this.inputCompanies != null && this.inputCompanies != "" && this.inputCompanies != []){
          payload["company_id"] = this.inputCompanies;
        }
        if(this.inputCategories != null && this.inputCategories != "" && this.inputCategories != []){
          payload["division_id"] = this.inputCategories;
        }
        if(this.inputProductCreateDate != null && this.inputProductCreateDate != "" && this.inputCategories != []){
          payload["from_created_at"] = this.inputProductCreateDate[0];
          payload["to_created_at"] = this.inputProductCreateDate[1];
        }
        if(this.inputProductUpdateDate != null && this.inputProductUpdateDate != "" && this.inputCategories != []){
          payload["from_updated_at"] = this.inputProductUpdateDate[0];
          payload["to_updated_at"] = this.inputProductUpdateDate[1];
        }
        if(this.inputYearSeason != null && this.inputYearSeason != "" && this.inputYearSeason != []){
          payload["year_season"] = this.inputYearSeason;
        }
        payload["type"] = this.filterStatus
        payload["custom_fields"] = customfield
        payload["export_type"] = this.inputExportType
        payload["status"] = this.inputStatus
        payload["current_site"] = this.site_id
        payload["is_ecomm_product"] = this.inputIsEcomm
        if(this.filterStatus == "alternate_barcode" && this.inputMallGroup){
          payload["mall_group_id"] = this.inputMallGroup
        }
      }

      if (this.checkedFields.length == 0) {
        payload["fields"] = this.availableFields;
      } else {
        payload["fields"] = this.checkedFields;
      }

      await axios({
        url: baseUrl + additional_parameters,
        method: "POST",
        responseType: "blob", // important
        headers: {
          Authorization: "Bearer " + secureStorage.getItem("accessToken"),
          "Access-Control-Allow-Origin": "*", 'Request-Source':"BXI-File", 'ip':secureStorage.getItem("ipAddress") 
        },
        data: payload,
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        if(this.filterStatus == 'item_master'){
          link.setAttribute("download", "item_master.csv");
        }else if(this.filterStatus == 'ecom_master'){
          link.setAttribute("download", "ecom_master.csv");
        }else if(this.filterStatus == 'ns_item_master'){
          link.setAttribute("download", "ns_item_master.csv")
        }else if(this.filterStatus == 'alternate_barcode'){
          link.setAttribute("download", "alternate_barcode.csv");
        }else{
          link.setAttribute("download", "product_combined.csv");
        }
        document.body.appendChild(link);
        link.click();
        this.onClose();
        this.filterStatus = 'item_master';
        this.inputProductCreateDate = [moment().startOf('day'), moment().endOf('day')]
        this.inputProductUpdateDate = []
        this.inputBrands = []
        this.inputCompanies = []
        this.inputCategories= []
        this.inputMallGroup = null
        this.inputYearSeason = null
        this.inputExportType = 'piml'
        this.inputStatus = "A"
        // this.successMessage = "Download successful"
        this.$notification["success"]({
          message: "Download Successful",
          description: "You have successfully downloaded your product list.",
        });
      });
      this.spinningDownload = false
    },
    displayMessage(message) {
      if (message["error"] != undefined) {
        this.onClose();
        this.errorMessage = message["error"];
        this.successMessage = null;
      }
    },
    removeMessage(type) {
      if (type == "error") this.errorMessage = null;
      else this.successMessage = null;
    },
    iconSourcePath(product_type){
      var image_path = "";
      switch(product_type){
        case '':
          image_path =  require('../../assets/icons/'+ this.icon_code + '/regular.png')
          break;
        case 'G':
          image_path =  require('../../assets/icons/'+ this.icon_code + '/regular.png')
          break;
        case 'P':
          image_path =  require('../../assets/icons/'+ this.icon_code + '/packaged.png')
          break;
        case 'N':
          image_path =  require('../../assets/icons/'+ this.icon_code + '/non_inventory.png')
          break;
        case 'S':
          image_path =  require('../../assets/icons/'+ this.icon_code + '/serial.png')
          break;
        case 'K':
          image_path =  require('../../assets/icons/'+ this.icon_code + '/kit.png')
          break;
        case 'V':
          image_path =  require('../../assets/icons/'+ this.icon_code + '/virtual_kit.png')
          break;
        case 'M':
          image_path =  require('../../assets/icons/'+ this.icon_code + '/matrix.png')
          break;
        case 'B':
          if(this.icon_code == 'FNB'){
            image_path =  require('../../assets/icons/'+ this.icon_code + '/combo.png')
          }else{
            image_path =  require('../../assets/icons/'+ this.icon_code + '/regular.png')
          }
          break;
        case 'R':
          image_path =  require('../../assets/icons/'+ this.icon_code + '/recipe.png')
          break;
        default:
          image_path =  require('../../assets/icons/'+ this.icon_code + '/regular.png')
          break;
      }
      return image_path;
    },
    showChildrenProducts(id) {
      this.$router.push("/children_products/" + id);
    },

    showTestImportModal(){
      this.viewTestImportModal = true
    },
    handleClose(){
      this.viewTestImportModal = false
      this.componentModal += 1;
    },

    handleOk(){
      this.viewTestImportModal = false
      this.componentModal += 1;
    }
  },
};
</script>

<style>
.ant-table-row-level-1 {
  background-color: #e6f7ff;
}
.product-icons{
  margin-right: 7px;
  height: 15px;
  width: 15px;
}
.table-product-icons{
  position: absolute;
  margin: -23px;
  margin-top: 3px;
  height: 15px;
  widows: 15px;
}
</style>
